<template>
    <b-container class="">
        <b-row v-if="loading">
            <b-col>
                <div class="mobile-card detskel">
                    <div class="d-flex gap-5 mb-2">
                        <Skeleton width="14rem" class="mb-2"></Skeleton>
                        <Skeleton width="5rem" class="mb-2"></Skeleton>
                    </div>
                    <div class="d-flex gap-5">
                        <div class="d-flex gap-3">
                            <Skeleton width="7rem" class="mb-2"></Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                        <div class="d-flex gap-3">
                            <Skeleton width=" 7rem" class="mb-2">
                            </Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                    </div>
                    <div class="d-flex gap-5">
                        <div class="d-flex gap-3">
                            <Skeleton width="7rem" class="mb-2"></Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                        <div class="d-flex gap-3">
                            <Skeleton width=" 7rem" class="mb-2">
                            </Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                    </div>
                    <div class="d-flex gap-5">
                        <div class="d-flex gap-3">
                            <Skeleton width="7rem" class="mb-2"></Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                        <div class="d-flex gap-3">
                            <Skeleton width=" 7rem" class="mb-2">
                            </Skeleton>
                            <Skeleton shape="circle" size="1rem" class="me-2"></Skeleton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row v-else>
            <!-- {{ details }} -->
            <b-col>

                <div class="details_banner">
                    <div class="d-flex justify-content-end">
                        <!-- <OrangeStatus :name="details.Status" v-if="details.Status" /> -->
                        <OrangeStatus name="Pending" v-if="details.Status == '0'" />
                        <OrangeStatus name="Converted To PI" v-if="details.Status == '1'" />
                        <GreenStatus name="Issued" v-if="details.Status == '2'" />
                        <BlueStatus name="Partially Issued" v-if="details.Status == '3'" />
                        <BlueStatus name="Converted to PR" v-if="details.Status == '4'" />
                        <BlueStatus name="Partially Converted to PR" v-if="details.Status == '5'" />
                        <RedStatus name="Closed" v-if="details.Status == '6'" />
                        <RedStatus name="Cancelled" v-if="details.Status == '7'" />
                    </div>
                    <div class="detailsbannertop mt-1">
                        <span v-if="details.id" class="id">{{ details.id }}</span>
                        <span v-if="details.date" class="date">{{ details.date == "Invalid date" ? "-" : details.date
                            }}</span>
                    </div>
                    <div class="detailsbannertop mt-1">
                        <span v-if="details.RequesterName" class="">{{ details.RequesterName }}</span>
                        <span v-if="details.RequestCategory" class="date">{{ details.RequestCategory }}</span>
                    </div>
                    <div class="stores mt-2">
                        <p v-if="details.fromstr || details.fromcount">
                            <span v-if="details.fromstr" :title="details.fromstr">{{ details.fromstr }}</span>
                            <OrangeStatus :name="details.fromcount" v-if="details.fromcount" />
                            <OrangeStatus :name="0" v-else />

                        </p>
                        <p v-if="details.tostr || details.tocount">
                            <span v-if="details.tostr" :title="details.tostr">{{ details.tostr }}</span>
                            <GreenStatus :name="details.tocount" v-if="details.tocount" />
                            <GreenStatus :name="0" v-else />

                        </p>
                    </div>
                    <div v-if="details.MarkasUrgent" class="d-flex align-items-center my-3">
                        <span v-if="details.MarkasUrgent" class="id me-2">Mark as Urgent: </span>
                        <Checkbox v-model="details.MarkasUrgent" inputId="UrgentRequest" name="urgentrequest"
                            :value="true" disabled binary />

                        <!-- <span v-if="details.Remarks" class="date">{{ details.Remarks }}</span> -->
                    </div>
                    <div class="d-flex align-items-center">
                        <span v-if="details.Remarks" class="id me-2">Remarks: </span>

                        <span v-if="details.Remarks" class="date">{{ details.Remarks }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
export default defineComponent({
    props: {
        details: {
            type: Object,
            default: {}
        },
        loading: {
            type: Boolean,
            default: false
        },
    },

    setup(props) {
        let showdetails = ref(false);
        if (props.details) {
            showdetails.value = true;
        }
        return {
            showdetails
        };
    },
});
</script>
<style>
.detskel {
    width: max-content;
}

.details_banner {
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #e1e1e1;
    padding: 15px;
    width: max-content;

    .detailsbannertop {
        display: flex;
        gap: 50px;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;

        .id {
            color: #999999;
        }

        .date {
            color: #999999;
        }
    }


    .stores {
        display: flex;
        gap: 15px;
        align-items: center;
        justify-content: space-between;
        color: #999999;


        >p {
            display: flex;
            align-items: center;
            gap: 15px;

            >span:first-of-type {
                display: inline-block;
                color: #999999;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>